// packages/ui/src/components/activity/FilterBar.tsx
// Filter bar with dropdowns for channel, tool, host, and severity

export interface ActivityFilters {
  channel: string
  tool: string
  host: string
  severity: string
}

export interface FilterBarProps {
  filters: ActivityFilters
  onChange: (filters: ActivityFilters) => void
  channels?: string[]
  tools?: string[]
  hosts?: string[]
}

const SEVERITY_OPTIONS = ['all', 'info', 'warn', 'error', 'critical']

export function FilterBar({ filters, onChange, channels = [], tools = [], hosts = [] }: FilterBarProps) {
  const update = (key: keyof ActivityFilters, value: string) => {
    onChange({ ...filters, [key]: value })
  }

  return (
    <div data-testid="filter-bar" className="flex flex-wrap items-center gap-3 px-4 py-3 border-b border-gray-800 bg-gray-900/50">
      <label className="flex items-center gap-1.5">
        <span className="text-xs text-gray-500">Channel</span>
        <select
          data-testid="filter-channel"
          className="bg-gray-800 border border-gray-700 text-gray-200 text-sm rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
          value={filters.channel}
          onChange={(e) => update('channel', e.target.value)}
        >
          <option value="all">All</option>
          {channels.map((ch) => (
            <option key={ch} value={ch}>{ch}</option>
          ))}
        </select>
      </label>

      <label className="flex items-center gap-1.5">
        <span className="text-xs text-gray-500">Tool</span>
        <select
          data-testid="filter-tool"
          className="bg-gray-800 border border-gray-700 text-gray-200 text-sm rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
          value={filters.tool}
          onChange={(e) => update('tool', e.target.value)}
        >
          <option value="all">All</option>
          {tools.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </label>

      <label className="flex items-center gap-1.5">
        <span className="text-xs text-gray-500">Host</span>
        <select
          data-testid="filter-host"
          className="bg-gray-800 border border-gray-700 text-gray-200 text-sm rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
          value={filters.host}
          onChange={(e) => update('host', e.target.value)}
        >
          <option value="all">All</option>
          {hosts.map((h) => (
            <option key={h} value={h}>{h}</option>
          ))}
        </select>
      </label>

      <label className="flex items-center gap-1.5">
        <span className="text-xs text-gray-500">Severity</span>
        <select
          data-testid="filter-severity"
          className="bg-gray-800 border border-gray-700 text-gray-200 text-sm rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
          value={filters.severity}
          onChange={(e) => update('severity', e.target.value)}
        >
          {SEVERITY_OPTIONS.map((s) => (
            <option key={s} value={s}>{s === 'all' ? 'All' : s}</option>
          ))}
        </select>
      </label>
    </div>
  )
}
